<template>

  <v-data-table
    :headers="headers"
    :items="_items"
    :server-items-length="_total"
    :footer-props="footer"
    :no-data-text="labels.nodata"
    :options.sync="options"
    :loading="loading"
    @click:row="$emit('click', $event)"
  >
    <template v-slot:item.period="{ item }">
      {{ item.period }} {{ $tc('days', item.period) }}
    </template>

    <template v-slot:item.actions="{ item }">
      <responsive-icon :label="$t('issues.edit')" breakpoints="xs">
        <font-awesome-icon icon="pen" size="lg"></font-awesome-icon>
      </responsive-icon>
    </template>

  </v-data-table>

</template>

<script>
  import dataTable from '../../helpers/data-table.es6'
  import ResponsiveIcon from '../../shared/components/responsive-icon'

  export default {
    name: 'planned-issues-table',
    mixins: [ dataTable ],

    data () {
      return {
        headers: [
          { text: this.$t('entityNames.issue-codes'), value: 'code' },
          { text: this.$tc('asset-types.entity-name', 1), value: 'assetTypeName' },
          { text: this.$tc('planned-issues.entity-name', 1), value: 'name' },
          { text: this.$t('period'), value: 'period' },
          { text: this.$t('shared.actions'), value: 'actions', sortable: false },
        ]
      }
    },

    components: {
      ResponsiveIcon
    }
  }
</script>

<style scoped lang="scss">

  @import '../../../assets/variables';

  ::v-deep {
    tbody tr {
      td {
        cursor: pointer;
      }
    }
  }

</style>
